import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  products: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filter: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  spaceTop: {
    marginTop: 30,
  },
  info: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'TCCC-UnityHeadline Regular',
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  spaceEq: {
    marginTop: 80,
  },
  termsLink: {
    marginTop: 16,
    color: Colors.RedPallete.red,
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 14,
  },
  containerButton: {alignSelf: 'center', width: '80%', marginTop: 20},
});
